<template>
    <div class="section0 section" id="section0">

        <!--<video playsinline="playsinline" id="eventVideo" autoplay="autoplay" muted="muted" loop="loop">
            <source src="video/thumb.mp4" type="audio/mp4">
        </video>-->

        <div class="inner">
            <div class="txtBox">
                <div v-if="!$store.state.isPreRegOpen"
                     style="max-width: 489px; width: 40%; margin: 0 auto 0; position: relative; z-index: 1;">
                    <img :src="`images/main-logo.png`"
                         style="width:100%;" />
                </div>
                <div class="subtit"
                     :class="{isRegClose: !$store.state.isPreRegOpen}">
                    <img :src="`images/section0-title-${$store.state.lang}.png`" />
                </div>
                <div class="reword-text">
                    <img :src="`images/section0-reword-${$store.state.lang}.png`" />
                </div>

                <div class="right-main">
                    <div class="ment">
                        <img :src="`images/section0-ment-${$store.state.lang}.png`" />
                    </div>
                
                    <div class="play-btn">
                        <a @click="openYoutubePopup">
                            <img :src="`images/section0-play-${$store.state.lang}.png`" />
                        </a>
                    </div>
                </div>
                <!-- <div class="releaseDate">
                    <a id="sectionMove" href="#section1" v-smooth-scroll
                       v-if="$store.state.isPreRegOpen">
                        <img :src="`images/section0-btn-${$store.state.lang}.png`" />
                    </a>
                    <a target="_blank"
                       href="https://store.steampowered.com/app/985810/GrandChase/"
                       v-else>
                        <img :src="`images/section0-btn-after-${$store.state.lang}.png`" />
                    </a>
                </div> -->
            </div>
            <div class="game-btns">
                 <a target="_blank"
                    href="https://store.steampowered.com/app/985810/GrandChase/">
                    <img src="images/steam-play-btn.png" />
                </a>
                 <a target="_blank"
                    href="https://store.onstove.com/games/104686 ">
                    <img src="images/stove-play-btn.png" />
                </a>
                <a target="_blank"
                    href="https://store.epicgames.com/p/grandchase-c03eb2">
                    <img src="images/epic-play-btn.png" />
                </a>
                <a target="_blank"
                    href="https://grandchaseclassic.beanfun.com/main">
                    <img src="images/gamania-btn.png" />
                </a>
                <a target="_blank"
                    href="https://gcc.playpark.com/">
                    <img src="images/park-play-btn.png" />
                </a>
            </div>
        </div>

        <!-- YouTube Popup -->
        <transition name="yt-fade">
            <div v-if="showYoutubePopup" class="youtube-popup-overlay" @click.self="closeYoutubePopup">
                <transition name="yt-scale">
                    <div v-if="showYoutubePopup" class="youtube-popup-inner">
                        <div class="youtube-popup-header">
                            <span class="youtube-popup-title">GRAND CHASE CLASSIC</span>
                            <button class="youtube-popup-close" @click="closeYoutubePopup">
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                        <div class="youtube-popup-frame">
                            <iframe
                                :src="`https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0`"
                                frameborder="0"
                                allow="autoplay; encrypted-media"
                                allowfullscreen
                            ></iframe>
                        </div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showYoutubePopup: false,
            }
        },
        computed: {
            youtubeId() {
                return this.$store.getters.getLangValue('youtubeIds')
            },
        },
        created() {

        },
        mounted() {
        },
        methods: {
            openYoutubePopup() {
                this.showYoutubePopup = true
            },
            closeYoutubePopup() {
                this.showYoutubePopup = false
            },
            eventGtag() {
                this.$gtag.event('Game Click', {
                    action_name: '게임바로가기 클릭'
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../assets/scss/_variables.scss';

    .section0 {
        position: relative;
        height: 100%;
        min-height: 100vh;
        max-width: 2560px;
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
        z-index: 3;

        @keyframes slideUpAnimation {
            from {
                opacity: 0;
                transform: translate3d(0,30px,0);
            }

            to {
                opacity: 1;
                transform: translate3d(0,0,0);
            }
        }

        @keyframes fadeUpItem {
            from {
                opacity: 0;
                transform: translate3d(0, 24px, 0);
            }

            to {
                opacity: 1;
                transform: translate3d(0, 0, 0);
            }
        }

        @keyframes fadeInRight {
            from {
                opacity: 0;
                transform: translate3d(28px, 0, 0);
            }

            to {
                opacity: 1;
                transform: translate3d(0, 0, 0);
            }
        }

        @keyframes gentleFloat {
            0%,
            100% {
                transform: translateY(0);
            }

            50% {
                transform: translateY(-6px);
            }
        }

        video {
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            min-width: 100%;
            min-height: 100%;
            width: auto;
            height: auto;
            z-index: 0;
            transform: translate(-50%, -50%);
        }

        .inner {
            width: 100%;
            max-width: 1920px;
            position: relative;
            margin: 0 auto;
            .charOpenDate {
                font-family: 'LTRemark';
                font-weight: bold;
                color: #959da8;
                position: absolute;
                top: 70px;
                left: 50%;
                transform: translateX(-50%);
                text-align: center;
                font-size: 44px;
                letter-spacing: 2px;
                line-height: 1em;
                -webkit-text-stroke: 1px darkslategrey;
                text-shadow: 0px 0px 100px #01495d;
            }
            .game-btns {
                display:flex;
                align-items: center;
                justify-content: center;
                margin-top: 40px;
                gap: 12px;
                flex-wrap: wrap;
                opacity: 0;
                animation: fadeUpItem 0.65s 0.75s forwards;

                a {
                    display: inline-flex;
                    opacity: 0;
                    transform: translate3d(0, 18px, 0);
                    animation: fadeUpItem 0.55s forwards;

                    img {
                        display: block;
                        max-width: 100%;
                        height: auto;
                    }

                    &:nth-child(1) {
                        animation-delay: 0.9s;
                    }

                    &:nth-child(2) {
                        animation-delay: 1.02s;
                    }

                    &:nth-child(3) {
                        animation-delay: 1.14s;
                    }

                    &:nth-child(4) {
                        animation-delay: 1.26s;
                    }

                    &:nth-child(5) {
                        animation-delay: 1.38s;
                    }
                }
            }

            .txtBox {
                display: block;
                overflow: hidden;
                padding-top:100px;
       
                @keyframes scaleUp {
                    0% {
                        transform: scale(0);
                        opacity: 0;
                    }

                    60% {
                        transform: scale(1.1);
                        opacity: 1;
                    }

                    100% {
                        transform: scale(1);
                    }
                }
                .right-main{
                    position: absolute;
                    right: 10px;
                    bottom: 60px;
                    text-align: right;
                    opacity: 0;
                    animation: fadeInRight 0.7s 0.5s forwards;

                    .ment {
                        opacity: 0;
                        animation: fadeUpItem 0.55s 0.62s forwards;
                    }

                    .play-btn {
                        opacity: 0;
                        animation: fadeUpItem 0.55s 0.78s forwards;

                        img {
                            animation: gentleFloat 2.2s 1.4s ease-in-out infinite;
                        }
                    }
                }

                > div:first-child {
                    opacity: 0;
                    animation: fadeUpItem 0.6s 0.1s forwards;
                }

                .subtit {
                    height: 100%;
                    position: relative;
                    display: inline-block;
                    animation: scaleUp 0.6s ease-out forwards;

                    &.isRegClose {
                        margin-top: -160px;
                    }

                    img {
                        margin-bottom: -30px;
                        width: 100%;
                    }

                    > div {
                        display: block;
                        animation: slideUpAnimation 0.6s 0.3s forwards cubic-bezier(0, 0, 0.2, 1);
                        opacity: 0;
                    }
                }
                .reword-text {
                    margin-left: 80px;
                    opacity: 0;
                    animation: fadeUpItem 0.6s 0.32s forwards;
                }
            }

            .releaseDate {
                font-weight: bold;
                position: relative;
                overflow: hidden;
                text-shadow: 0px 0px 10px rgba(0,0,0,0.5);

                span {
                    position: absolute;
                    top: 46.5%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 35px;
                    color: #eee;
                }
            }
        }

        .eventBox {
            display: flex;
            align-items: center;
            margin: 0;
            position: absolute;
            bottom: 80px;
            transform: translateX(-50%);
            left: 50%;
            width: 100%;
            z-index: 2;
            box-sizing: border-box;
            justify-content: center;

            li {
                width: 30%;
                border: solid 1px rgba(255,255,255,0.3);
                border-radius: 5px;
                overflow: hidden;

                &:nth-child(2) {
                    a {
                        border-left: solid 1px rgba(255,255,255,0.3);
                        border-right: solid 1px rgba(255,255,255,0.3)
                    }
                }

                .iconMove {
                    animation: moveIcon 1s alternate infinite;
                }

                @keyframes moveIcon {
                    0% {
                        transform: translateY(5px)
                    }

                    100% {
                        transform: translateY(-5px)
                    }
                }

                a {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: all 0.4s;
                    box-sizing: border-box;
                    width: 100%;
                    position: relative;
                    overflow: hidden;
                    height: 80px;
                    text-align: center;
                    background: #a12e42;
                    color: #fff;

                    &:hover {
                        background: #f1893c;
                        color: #fff;

                        span.detailBtn {
                            right: 10px;
                        }
                    }

                    > span {
                        display: block;
                        font-size: 24px;
                        font-weight: 500;

                        span {
                            display: block;
                        }
                    }
                }
            }
        }

        .yt-fade-enter-active,
        .yt-fade-leave-active {
            transition: opacity 0.3s ease;
        }
        .yt-fade-enter,
        .yt-fade-leave-to {
            opacity: 0;
        }
        .yt-scale-enter-active {
            transition: opacity 0.35s ease, transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
        .yt-scale-leave-active {
            transition: opacity 0.2s ease, transform 0.2s ease;
        }
        .yt-scale-enter,
        .yt-scale-leave-to {
            opacity: 0;
            transform: scale(0.88);
        }

        .youtube-popup-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.82);
            backdrop-filter: blur(6px);
            -webkit-backdrop-filter: blur(6px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;

            .youtube-popup-inner {
                position: relative;
                width: 90%;
                max-width: 1400px;
                border-radius: 6px;
                overflow: hidden;
                box-shadow: 0 30px 80px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255,255,255,0.07);

                .youtube-popup-header {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background: #0d0d0d;
                    padding: 12px 18px;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.08);

                    .youtube-popup-title {
                        font-size: 13px;
                        font-weight: 600;
                        letter-spacing: 2px;
                        color: rgba(255, 255, 255, 0.55);
                        text-transform: uppercase;
                    }

                    .youtube-popup-close {
                        position: relative;
                        width: 28px;
                        height: 28px;
                        background: rgba(255, 255, 255, 0.08);
                        border: 1px solid rgba(255, 255, 255, 0.12);
                        border-radius: 50%;
                        cursor: pointer;
                        padding: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: background 0.2s ease, border-color 0.2s ease;
                        flex-shrink: 0;

                        span {
                            position: absolute;
                            width: 12px;
                            height: 1.5px;
                            background: rgba(255, 255, 255, 0.7);
                            border-radius: 2px;
                            transition: background 0.2s ease;

                            &:first-child {
                                transform: rotate(45deg);
                            }

                            &:last-child {
                                transform: rotate(-45deg);
                            }
                        }

                        &:hover {
                            background: rgba(255, 80, 80, 0.25);
                            border-color: rgba(255, 80, 80, 0.4);

                            span {
                                background: #ff6b6b;
                            }
                        }
                    }
                }

                .youtube-popup-frame {
                    position: relative;
                    width: 100%;
                    padding-top: 56.25%;
                    background: #000;

                    iframe {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        border: none;
                        display: block;
                    }
                }
            }
        }

        @include laptop {
            .inner {
                .txtBox {
                    .tit {
                    }

                    .subtit {
                    }
                }

                .releaseDate {
                    span {
                        font-size: 25px;
                    }

                    img {
                        max-width: 400px;
                        width: 100%;
                    }
                }
            }

            .eventBox {
                li {
                    a {
                        height: 100px;

                        > span {
                            font-size: 20px;
                        }
                    }
                }
            }
        }

        @media all and (max-width: 1520px) {
            .inner {
                .game-btns {
                    a {
                        img {
                            width: 220px;
                            max-width: 100%;
                        }
                    }
                }
            }
        }

        @include tablet {
            min-height: auto;
            height: auto;
            margin: 0 auto;
            padding: 120px 0 60px;
            height: auto;

            &:after {
                display: none !important;
            }

            video {
                display: none;
            }

            .inner {
                width: 100%;
                max-width: 100%;
                .charOpenDate {
                    top: 30px;
                    width: 100%;

                    p {
                        font-size: 18px;
                        line-height: 18px;
                    }
                }

                &:after {
                    display: none !important;
                }

                padding: 0 10px;
                height: auto;

                .txtBox {
                    width: 100%;
                    text-align: center;
                    position: static;
                    transform: translateX(0);
                    padding-bottom: 0;
                    padding-top: 20px;

                    img {
                        width: auto;
                        height: 100%;
                        max-width: none;
                    }

                    .tit {
                        margin-right: 0;

                        a {
                            font-size: 16px;
                            display: block;

                            &:first-child {
                                margin: 0;
                                padding: 0;
                                border: none;
                            }
                        }
                    }

                    .subtit {
                        margin-top: -8px;
                        width: 100%;
                        max-width: 92%;
                        margin-left: auto;
                        margin-right: auto;

                        &.isRegClose {
                            margin-top: -50px;
                        }

                        img {
                            width: 100%;
                        }
                    }

                    .releaseDate {
                        img {
                            width: 100%;
                        }
                    }

                    .reword-text {
                        margin-left: 0;
                        width: 100%;
                        max-width: 88%;
                        margin-right: auto;
                        margin-left: auto;
                    }

                    .right-main {
                        position: static;
                        right: auto;
                        bottom: auto;
                        text-align: center;
                        margin-top: 16px;

                        .ment,
                        .play-btn {
                            display: inline-block;
                            width: 100%;
                            max-width: 90%;
                        }
                    }
                }

                .game-btns {
                    margin-top: 26px;
                    gap: 10px;

                    a {
                        width: calc(50% - 10px);
                        justify-content: center;
                    }
                }
            }

            .eventBox {
                flex-direction: column;
                position: static;
                margin-top: 40px;
                transform: translateX(0);
                border: none;

                li {
                    width: 95%;
                    margin: 2px 0;
                    overflow: hidden;

                    a {
                        overflow: hidden;
                        height: auto;
                        padding: 10px 0;
                        border: solid 1px #d2d2d2 !important;

                        > span {
                            width: 100%;
                            display: block;

                            br {
                                display: none;
                            }
                        }
                    }
                }
            }
        }

        @media all and (max-width: $tablet) {

            min-height: auto;
            height: auto;
            padding: 90px 0 44px;

            .inner {
                width: 100%;
                max-width: 100%;
                padding-top: 200px;

                .txtBox {
                    padding-top: 0;

                    img {
                        width: 100%;
                        height: auto;
                        max-width: 100%;
                    }

                    .newdatebox {
                        .new-date {
                            font-size: 12px;
                            width: 100%;
                            letter-spacing: 0;
                        }

                        img {
                            width: 100%;
                        }
                    }

                    .tit {
                        margin-top: 5px;

                        span {
                            line-height: 1em;
                            animation: none;
                            opacity: 1;
                        }
                    }

                    .subtit {
                        margin-bottom: 22px;

                        > div {
                            animation: none;
                            opacity: 1;
                        }
                    }

                    .reword-text {
                        width: 110%;
                        max-width: 110%;
                        margin-left: 50%;
                        margin-right: 0;
                        transform: translateX(-50%) !important
                    }

                    .right-main {
                        margin-top: 10px;

                        .ment,
                        .play-btn {
                            max-width: 72%;
                            margin-left: auto;
                            margin-right: auto;
                        }

                        .play-btn {
                            max-width: 62%;
                        }

                        .ment img,
                        .play-btn img {
                            width: 100%;
                            height: auto;
                            max-width: 100%;
                        }
                    }
                }

                .releaseDate {
                    span {
                        font-size: 14px;
                        animation: none;
                        opacity: 1;
                    }

                    img {
                        max-width: 300px;
                        width: 100%;
                    }
                }

                .scrollImg {
                    img {
                        width: 80px;
                    }
                }

                .game-btns {
                    margin-top: 20px;
                    gap: 8px;

                    a {
                        width: calc(50% - 8px);

                        &:last-child {
                            width: 100%;
                        }
                    }
                }
            }

            .eventBox {
                margin-top: 20px;

                li a > span {
                    font-size: 14px;
                }
            }
        }
    }
</style>
